var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('good-table',{ref:"vgTable",staticClass:"mt-1 fixed-column",attrs:{"columns":_vm.dataForm.columns,"rows":_vm.dataForm.rows,"pagination":false},on:{"selected-item":_vm.selectedItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }